const noop = () => void 0;
let DEBUG = false;
let TRACE = false;

export function isDebugEnabled() {
	return DEBUG
}

export function isTraceEnabled() {
	return TRACE
}

const DEBUG_LS_NAME = 'DEBUG';
const TRACE_LS_NAME = 'TRACE';
(function () {
	try {
		DEBUG = JSON.parse(localStorage[DEBUG_LS_NAME])
	} catch (ignore) {
		DEBUG = false
	}
	try {
		TRACE = JSON.parse(localStorage[TRACE_LS_NAME])
	} catch (ignore) {
		TRACE = false
	}
})()

export const log = {
	assert: console.assert || noop,
	info: console.info || noop,
	warn: console.warn || noop,
	error: console.error || noop,
	debug: DEBUG && console.log || noop,
	trace: TRACE && console.log || noop,
};
window.log = log;

function enable(LS_NAME) {
	localStorage[LS_NAME] = true
	return 'enabled, please refresh'
}

function disable(LS_NAME) {
	localStorage[LS_NAME] = false
	return 'disabled, please refresh'
}

window.sis = {
	...window.sis,
	log,
	dbg: (TRACE || DEBUG) && (() => setTimeout(() => {
		// for UI debugging of temporary ui elements, i.e. tooltip, select menu
		debugger;
	}, 2000)),
	enableDebug: () => enable(DEBUG_LS_NAME),
	disableDebug: () => disable(DEBUG_LS_NAME),
	enableTrace: () => enable(TRACE_LS_NAME),
	disableTrace: () => disable(TRACE_LS_NAME),
	enableAll: () => {
		window.sis.enableDebug()
		window.sis.enableTrace()
		log.warn('reload!')
	},
}